<template>
  <div
    class="step-number"
    :class="{ 'step-number--with-line': showTopBorder, 'step-number--compact': compact }"
  >
    <div class="step-number__content">
      Step {{ stepNumber }}: <span class="step-number__content--light">{{ content }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "StepNumber",
  props: {
    content: {
      type: String,
      required: true
    },
    stepNumber: {
      type: [Number, String],
      default: 1
    },
    showTopBorder: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";

.step-number {
  font-family: $font-family-secondary;
  margin: 5px 0 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &--compact {
    margin: 5px 0;
  }

  &--with-line {
    border-top: 1px solid $app-gray-modern-300;
    padding-top: 20px;
  }

  &__content {
    font-family: inherit;
    font-size: 17px;
    font-weight: 700;
    line-height: 19px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    &--light {
      color: $app-gray-modern-600;
      margin-left: 5px;
    }
  }
}
</style>
